import { render } from "./AddGpsReportForMatch.vue?vue&type=template&id=b3fbd600&scoped=true"
import script from "./AddGpsReportForMatch.vue?vue&type=script&lang=js"
export * from "./AddGpsReportForMatch.vue?vue&type=script&lang=js"

import "./AddGpsReportForMatch.vue?vue&type=style&index=0&id=b3fbd600&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3fbd600"]])

export default __exports__